import * as types from '../constants/action-types';
import { Nux } from '../../../../api/api-nux';
import { Profile } from '../../../../api/api-profile';

export const fetchUserNux = (query) => (dispatch, getState) => {
  const { auth = {} } = getState();
  dispatch({ type: types.FETCH_NUX_REQUEST, error: '' });

  Nux.read(query, auth.accessToken, (response) => {
    if (response.error || 200 !== response.statusCode) {
      return dispatch({ type: types.FETCH_NUX_FAILURE, error: response.error });
    }
    const { data } = response;
    return dispatch({ type: types.FETCH_NUX_SUCCESS, error: '', experiences: data });
  });
};

export const updateExperience = (experienceId) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    const { auth = {}, nux = {} } = getState();
    dispatch({ type: types.PROFILE_UPDATE_REQUEST });
    const path = `me/experience/${experienceId}`;
    Profile.update(path, auth.accessToken, { complete_exp: true }, (response) => {
      if (response.error || 200 !== response.statusCode) {
        return reject(dispatch({ type: types.PROFILE_UPDATE_FAILURE, error: response.error }));
      }
      const { experiences: nuxExperiences = [] } = nux;
      const profile = _.get(response, ['data', 'profile'], {});
      const expId = _.get(response, ['data', 'experience', '_id'], '');
      const filterExperiences = _.filter(nuxExperiences, (item) => item._id !== expId);
      dispatch({ type: types.UPDATE_NUX_SUCCESS, experiences: filterExperiences });
      return resolve(dispatch({ type: types.PROFILE_UPDATE_SUCCESS, error: '', profile }));
    });
  });
};
